module.exports = __webpack_public_path__ + "img/detail_ai.a8b0373b.png";